import type { KnowledgeLearningScope } from "./types.js";

export const KNOWLEDGE_CONTENT_VERSION = "2";

export function learningStorageKey(
  scope: KnowledgeLearningScope | undefined,
): string | null {
  if (!scope?.tenantId || !scope.userId) return null;
  return (
    "pb:knowledge:" +
    KNOWLEDGE_CONTENT_VERSION +
    ":" +
    encodeURIComponent(scope.tenantId) +
    ":" +
    encodeURIComponent(scope.userId)
  );
}

export function readLearningProgress(key: string | null): readonly string[] {
  if (!key) return [];
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key) ?? "[]");
    return Array.isArray(value)
      ? [
          ...new Set(
            value.filter((id): id is string => typeof id === "string"),
          ),
        ].slice(0, 500)
      : [];
  } catch {
    return [];
  }
}

export function saveLearningProgress(
  key: string | null,
  ids: readonly string[],
): void {
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify(ids));
  } catch {
    // Reading still works when the browser refuses preference storage.
  }
}
